// extracted by mini-css-extract-plugin
module.exports = {"double__cta":"bn_fL","double__cta__button":"bn_fM","double__cta__button_alt":"bn_fN","wrapper":"bn_s"};